<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="6">
        <v-select
          :items="items"  v-model="item"
          label="Select an option"
           v-on:change="selectChange""
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      items: ['40','41','42','43','44','45','46','47','48','49',
               '50','51','52','53','54','55','56','57','58','59',
              '60','61','62','63','64','65','66','67','68','69',
              '70','71','72','73','74','75','76','77','78','79',
              '80','81','82','83','84','85','86','87','88','89',
              '90','91','92','93','94','95','96','97','98','99',
              '100','101','102','103','104','105','106','107','108','109',
              '110','111','112','113','114','115','116','117','118','119',
              '120','121','122','123','124','125','126','127','128','129',
              '130','131','132','133','134','135','136','137','138','139']
    }),
     methods: {
        selectChange: function(item){
            this.$emit('change', item)
        }
    }
  }
</script>
